module.exports = "<div class=\"jumbotron\">\r\n  <h1 class=\"display-3\">Welcome Admin!</h1>\r\n  <p>You can manage your site from here.....</p>\r\n</div>"